module.exports = __webpack_public_path__ + "img/img_b@2x.0d2a7245.png";